import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import Flex from '../Flex';
import { CollapseChevron } from './CollapseChevron';
import { useCollapse } from './context';

/**
 * @param {object} props
 * @param {string} [props.className='']
 * @param {React.ReactNode} [props.children=null]
 * @param {({ isOpen: boolean }) => React.ReactNode} [props.render] - render prop which receives `{ isOpen }` as argument
 */
export function CollapseTrigger({
  className = '',
  children = null,
  render = () => null,
}) {
  const { isOpen, onToggle } = useCollapse();

  const content = render({ isOpen }) || children;

  return (
    <Flex
      gap={4}
      align="center"
      justify="center"
      onClick={onToggle}
      data-open={isOpen}
      data-type={!!content ? 'button' : 'icon'}
      className={cn(styles.trigger, className)}
    >
      {content || <CollapseChevron />}
    </Flex>
  );
}
